import { Component, HostListener, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnInit } from '@angular/core';

@Component({
    selector: 'shared-hints-popup',
    templateUrl: './hints-popup.shared.component.html',
    styleUrls: ['./hints-popup.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HintsPopupComponent implements OnInit {
    private _isOpen: boolean = false;
    private _popoverTimeToClose: number = 4000;

    @Input() public icon: string = '?';
    @Input() public inverted: boolean = false;
    @Input() public disabled: boolean = false;
    @Input() public size: OLO.Components.BADGE_SIZE = 'xs';
    @Input() public type: OLO.Components.BADGE_TYPE = 'primary';
    @Input() public isAnimating: boolean = false;
    @Input() public shouldBeVisibleOnInit: boolean = false;
    @Input() public boldText: boolean = false;
    @Input() public position: OLO.Components.HINT_POSITION = 'top';

    @HostListener('window:click') public windowClicked($event: Event): void {
        this._isOpen = false;
    }

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
    ) { }

    public ngOnInit(): void {
        if (this.shouldBeVisibleOnInit) {
            this._showPopoverForCertainTime();
        }
    }

    private _showPopoverForCertainTime(): void {
        this._isOpen = true;
        setTimeout(() => {
            if (this._isOpen) {
                this._isOpen = false;
                this.changeDetectorRef.detectChanges();
            }
        }, this._popoverTimeToClose);
    }

    public get isOpen(): boolean {
        return this._isOpen;
    }

    public onIndicatorClick($event: Event): void {
        if (this.isOpen) {
            $event.stopPropagation();
        }

        setTimeout(() => {
            this._isOpen = true;
            this.changeDetectorRef.detectChanges();
        }, 0);
    }

    public onBodyClick($event: Event): void {
        $event.stopPropagation();
    }
}
